import React, {Component} from 'react';
import PropTypes from 'prop-types';
import media from '../MediaQueries.js';
import styled from 'styled-components';

import { Collapse, Input, InputGroup, InputGroupButton, FormFeedback, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem,
        NavLink, Container, Row, Col, Jumbotron, Button, ButtonGroup, Dropdown, DropdownToggle } from 'reactstrap';
import { Link } from 'react-router-dom';


export default class ShopCurrentFilters extends Component {
  static propTypes = {
    productTypeInfo_DictionaryArray: PropTypes.array.isRequired,
    usableProductsCount: PropTypes.number.isRequired,
    togglePureMaple: PropTypes.func.isRequired,
    toggleExtraValue: PropTypes.func.isRequired,
    toggleNonMaple: PropTypes.func.isRequired,
    pureMapleCheck: PropTypes.func.isRequired,
    extraValueCheck: PropTypes.func.isRequired,
    nonMapleCheck: PropTypes.func.isRequired,
    pureSyrupCheck: PropTypes.func.isRequired,
    pureCreamCheck: PropTypes.func.isRequired,
    pureCandyCheck: PropTypes.func.isRequired,
    pureSugarCheck: PropTypes.func.isRequired,
    extraSaucesCheck: PropTypes.func.isRequired,
    extraBeveragesCheck: PropTypes.func.isRequired,
    extraCandyCheck: PropTypes.func.isRequired,
    extraJellyCheck: PropTypes.func.isRequired,
    extraGiftSetsCheck: PropTypes.func.isRequired,
    nonPancakeMixesCheck: PropTypes.func.isRequired,
    nonInformationalCheck: PropTypes.func.isRequired,
    nonClothesCheck: PropTypes.func.isRequired,
    nonCandlesCheck: PropTypes.func.isRequired,
    nonKitchenwareCheck: PropTypes.func.isRequired,
    nonBooksCheck: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props);

    this.state = {

    };
  }

  render() {
    var FiltersDisplayArray = [];

    this.props.productTypeInfo_DictionaryArray.map((productTypeInfo, index, dictionary) => {
      {productTypeInfo.IsActiveFilter ?
        FiltersDisplayArray.push( 
          <span key={index}>
            {' '}{ productTypeInfo.FilterDisplay }<span> [<CloseFilterX onClick={this.props[productTypeInfo.CheckedFunction]}> x </CloseFilterX>] </span>
          </span>
        )
        : ""
      }
    });

    return (
      <FluidContainer className="p-0" fluid>
        <FiltersViewContainer>
            <p>Filters: </p>
            {FiltersDisplayArray.length > 0 ? <span>({FiltersDisplayArray})</span> : <span>No filters selected</span>}

            <p>{this.props.usableProductsCount} Items</p>
        </FiltersViewContainer>
      </FluidContainer>
    );
  }
}

const CloseFilterX = styled.span`
  color: #822D08!important;
  font-weight: bold;
  cursor: pointer;
  font-size: 20px!important;
`;

const FiltersViewContainer = styled.div`
  margin: 10px 0 16px 0;
  text-align: center;

  p:nth-of-type(1) { display: inline; }
  p:nth-of-type(2) { font-size: 16px!important; }
  span { font-size: 15px; }
  
  ${media.md` 
    text-align: left;
    padding: 0;
    p:noth-of-type(2) {text-align: center;}
  `}
  ${media.lg`
    p:nth-of-type(1) { font-size: 22px!important; }
    p:nth-of-type(2) { font-size: 18px!important; }
    span { font-size: 16px; }
  `}
  ${media.xl`
    p:nth-of-type(1) { font-size: 24px!important;  }
    p:nth-of-type(2) { font-size: 20px!important; }
    span { font-size: 17px; }
  `}

`;

const FluidContainer = styled(Container)`  `;
const InternalContainer = styled(Container)`  `;

const Container_Under768 = styled(Container)`  `;

/*
const ListViewContainer = styled(({ listSelected, ...rest }) => <Container {...rest} />)`
	display: ${a => a.listSelected ? "block" : "none"};
  ${media.sm` background-image: url(${smHeroImage}); height: 362px; `}
`;
*/


// WEBPACK FOOTER //
// ./src/components/ShopCurrentFilters.js